import axios from 'axios';
import { USER_LOAD } from '../../utils/constants';

export const login = data =>
  axios
    .post(`/api/login`, data)
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const loadUser = () => async dispatch => {
  try {
    const response = await axios.post(`/api/user`);
    dispatch({
      type: USER_LOAD,
      payload: response.data,
    });

    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
};

export const logout = data =>
  axios
    .post(`/api/logout`)
    .then(response => response.data)
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/login/_api.js